export const appBaseURL = "/v2"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"stylesheet","href":"https://cdn.soma.lv/polar/froont-export-main.css"},{"rel":"stylesheet","href":"https://cdnjs.cloudflare.com/ajax/libs/KaTeX/0.13.13/katex.min.css"}],"style":[],"script":[{"src":"https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?features=IntersectionObserver,ResizeObserver,WebAnimations,Object.fromEntries,Array.prototype.at"},{"src":"https://unpkg.com/@dotlottie/player-component@1.0.0/dist/dotlottie-player.js"},{"src":"https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"},{"src":"https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.js"},{"type":"text/javascript","innerHTML":"\n          window.hideBeacon = function() {\n            const style = document.createElement('style');\n            style.id = 'hide-beacon-style';\n            style.innerHTML = '              #beacon-container {                display: none !important;              }            ';\n            document.head.appendChild(style);\n          };\n\n          window.unhideBeacon = function() {\n            const styleTag = document.getElementById('hide-beacon-style');\n            if (styleTag) {\n              styleTag.parentNode.removeChild(styleTag);\n            }\n          };\n          "},{"type":"text/javascript","innerHTML":"!function(e,t,n){function a(){var e=t.getElementsByTagName(\"script\")[0],n=t.createElement(\"script\");n.type=\"text/javascript\",n.async=!0,n.src=\"https://beacon-v2.helpscout.net\",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],\"complete\"===t.readyState)return a();e.attachEvent?e.attachEvent(\"onload\",a):e.addEventListener(\"load\",a,!1)}(window,document,window.Beacon||function(){});"},{"type":"text/javascript","innerHTML":"\n          window.helpdeskId = function () {\n            var teacherId = '2324da1d-67fa-4a3d-8fa8-571f11919894';\n            var othersId = '549f7b54-60f4-4ec9-a961-4dfd19a2b22c';\n\n            var user = localStorage.getItem('user:current');\n            var isTeacher = (JSON.parse(user) || {}).user_type === 'teacher';\n            window.console.log('[HELPSCOUT] You are ' + (isTeacher ? 'teacher' : 'other'));\n            window.currentHelpdeskId = isTeacher ? teacherId : othersId;\n\n            return window.currentHelpdeskId;\n          };\n\n          window.initBeacon = function() {\n            window.Beacon('init', window.helpdeskId());\n          };\n\n          window.destroyBeacon = function() {\n            window.Beacon('destroy');\n          };\n\n          window.openBeacon = function() {\n            window.Beacon('open');\n          };\n\n          !window.location.pathname.match(\"/auth/\") && window.initBeacon();\n        "},{"type":"text/javascript","innerHTML":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag(\"consent\", \"default\", { ad_storage: \"deny\", analytics_storage: \"deny\", wait_for_update: 500 });\n          "},{"src":"https://www.googletagmanager.com/gtag/js?id=G-Y1YS2EZBF6","async":true},{"innerHTML":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n\n            gtag('set', {});\n\n            gtag('config', 'G-Y1YS2EZBF6')\n        "}],"noscript":[],"htmlAttrs":{"lang":"lv"}}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true